import React from "react";
import { Dialog } from "@mui/material";
import MessagesChat from "components/MessagesChat";

const ClientSMSDialog = (props) => {
  const { onCloseDialog, open, teamMemberUserId } = props;

  if (!teamMemberUserId) return null;

  return (
    <Dialog
      open={open}
      onClose={onCloseDialog}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          height: "80vh",
          maxHeight: "80vh",
        },
      }}
    >
      <MessagesChat
        memberId={teamMemberUserId}
        refetchPreviews={() => {}}
        externalTriggerRefetch={() => {}}
        closeModal={onCloseDialog}
      />
    </Dialog>
  );
};

export default ClientSMSDialog;
